import { reclaimGroundAuth } from '~/modules/auth/api/ground-oauth.api';
import { useAuthStore } from '~/modules/auth/stores/auth.store';
import { ApiException } from '~/shared/errors/ApiException';

/**
 * Middleware обеспечивающая oauth сценарий авторизации через lims
 * На данный момент ЛИМС не поддерживает бесшовный сценарий авторизации,
 * поэтому реализуем "костылём" с нашей стороны
 *
 * 1. Если пользователь пришёл на /ground-auth-redirect и у него нет авторизации в cloud
 *    пишем в куки намерение пользователя уйти в ground и перенаправляем его в ЛИМС
 * 2. Если с наличием данной куки, пользователь посетит /lims-auth-redirect, то после подтверждения
 *    его авторизации мы можем автоматически перенаправить его в граунд
 *
 * NOTE ! Куку необходимо затирать при любом посещении любой другой страницы
 *
 * TODO(): После обработки oauth сценария в ЛИМС убрать костыль на стороне CLOUD
 */

export default defineNuxtRouteMiddleware(async (to, _) => {
  const { path } = to;
  const { token, backUrl } = to.query as { token: string; backUrl?: string };

  // useCookie требует контекста Nuxt и потому вызывается внутри middleware,
  // а не в области модуля: в области модуля вызов происходит на этапе импорта
  const groundAuthCookies = useCookie<{ token: string; backUrl?: string } | null>('ground-auth', {
    default: () => null,
  });

  const authStore = useAuthStore();

  if (path === '/lims-auth-redirect') {
    try {
      await authStore.authorize(token);

      if (groundAuthCookies.value == null) return backUrl || '/';
      const { redirectUrl } = await reclaimGroundAuth(groundAuthCookies.value.token);

      await navigateTo(redirectUrl, { external: true });
    } catch (error) {
      if (!(error instanceof ApiException)) {
        throw error;
      }
      return '/auth/not-authorized';
    }
  }

  if (path === '/ground-auth-redirect') {
    if (!authStore.isLoggedIn) {
      const redirectToLimsUrl = authStore.getSignInUrl('/ground-auth-redirect');
      groundAuthCookies.value = { token: token, backUrl: backUrl };

      await navigateTo(redirectToLimsUrl, { external: true });
    }

    const { redirectUrl } = await reclaimGroundAuth(token);
    await navigateTo(redirectUrl, { external: true });
  }

  groundAuthCookies.value = null;
});
